var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view-alt-1-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_106",
    "data-name": "Union 106",
    d: "M3.6,5.539A2.434,2.434,0,0,1,6,3.077,2.432,2.432,0,0,1,8.4,5.539,2.432,2.432,0,0,1,6,8,2.434,2.434,0,0,1,3.6,5.539ZM9.972,3.37A4.383,4.383,0,0,0,6,1.231,4.39,4.39,0,0,0,2.026,3.37a6.276,6.276,0,0,0-.833,2.248L0,5.463a7.434,7.434,0,0,1,.987-2.71A5.582,5.582,0,0,1,6,0a5.58,5.58,0,0,1,5.014,2.753A7.421,7.421,0,0,1,12,5.463l-.6.076-.6.079A6.25,6.25,0,0,0,9.972,3.37Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.79d1be0d209b7c6cff6a2ca8cb6edede.svg";
export { ForwardRef as ReactComponent };